import { atom, useResetRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";

export const accessTokenState = atom({
  key: "accessTokenState",
  default: "",
});

export const refreshTokenState = atom({
  key: "refreshTokenState",
  default: "",
});

//로그아웃 함수
export const useLogout = () => {
  const history = useNavigate();

  return () => {
    localStorage.clear();
    sessionStorage.clear();
    history("/login");
  };
};
